import FormControl from '@material-ui/core/FormControl';
import {FormField} from 'cl-form/FormFields';
import * as React from 'react';
import {FormSelectProps} from 'cl-form/FormSelect';
import Select from '@material-ui/core/Select';
import TemplateSelectPopover from '../../../../MyAccount/Listings/TemplateSelectPopover';
import {withStyles, WithStyles, createStyles} from '@material-ui/core/styles';
import {findDOMNode} from 'react-dom';
import * as _ from 'lodash';
import {getTemplatesById} from '../../../selectors/templatesSelectors';
import MenuItem from '@material-ui/core/MenuItem';
import Img, {IMG_SIZES} from '../../Img/Img';
import connectWithRouter from '../../redux/connectWithRouter';
import {StoreState} from '../../../../App/initialStore';

const styles = createStyles({
  formControl: {
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
});

@connectWithRouter((state: StoreState) => ({
  templates: getTemplatesById(state),
}))
class EbayTemplateSelect extends React.Component<
  FormSelectProps & WithStyles<typeof styles> & {templates: any; classes: any},
  {}
> {
  state = {
    open: false,
  };

  field;

  onSelect = templateId => {
    const {
      input: {onChange},
    } = this.props;
    this.setState({open: false});
    onChange(_.toString(templateId));
  };

  render() {
    const {
      input,
      templates,
      instructionText,
      explanationText,
      instructionPosition,
      showErrors,
      meta: {error, touched},
      classes: {formControl},
    } = this.props;
    const {open} = this.state;
    const template = templates[input.value];
    return (
      <FormField
        error={error}
        touched={touched}
        showErrors={showErrors}
        explanationText={explanationText}
        instructionText={instructionText}
        instructionPosition={instructionPosition}
        fieldName={input.name}
      >
        <FormControl
          className={formControl}
          ref={ref => {
            if (ref) this.field = findDOMNode(ref);
          }}
        >
          <Img
            size={IMG_SIZES.Mini}
            src={[template ? template.thumbnailUrl : undefined, '//via.placeholder.com/48x120']}
          />
          <Select onClick={() => this.setState({open: true})} value={input.value} open={false} onOpen={() => {}}>
            <MenuItem key={input.value} value={input.value}>
              {template ? template.name : undefined}
            </MenuItem>
          </Select>
          <TemplateSelectPopover
            open={open}
            onSelect={this.onSelect}
            onClose={() => this.setState({open: false})}
            anchorEl={this.field}
          />
        </FormControl>
      </FormField>
    );
  }
}

export default withStyles(styles)(EbayTemplateSelect);
